import React, {Fragment} from 'react';
import "./ui/home/Home.scss";
import {ChartList} from "./ui/charts/ChartList";
import HomeMetrics from "./ui/home/HomeMetrics";
import {AccountService} from "./services/AccountService";
import {getContainer} from "./ioc/IOCSetup";
import {Currency} from "./http/protocol";



interface State {
    currencies: Currency[];
    selectedCurrency: string;
}


export class Home extends React.Component<{},State> {
    accountService: AccountService;

    constructor(props: {}) {
        super(props);
        this.accountService = getContainer().getAccountService();
    }
    componentDidMount(): void {
        let activeCurrency = window.localStorage.getItem("activeCurrency");
        if(activeCurrency) {
            this.setState({selectedCurrency:activeCurrency})
        } else {
            this.accountService.getCurrencies().then((data)=>{
                if(data.length > 0 && data[0].code) {
                    this.setState({currencies:data, selectedCurrency: data[0].code})
                }
            })
        }
    }

    render() {
            return (
                <Fragment>
                    <h3>Dashboard</h3>
                    {this.state != null && this.state.selectedCurrency && (<HomeMetrics currency={this.state.selectedCurrency}/>)}
                    <ChartList byTag={"home"}/>
                </Fragment>
            );
        }
}
